import goTo from 'vuetify/es5/services/goto'
import { packageDeliveStoreInitState } from '../utils/vuex-store-init/packageDeliveInit.util'

export const state = () => (
  packageDeliveStoreInitState()
)

export const getters = {
  totalPackageAmout: state => {
    const packageList = state.packageList
      .filter(thePackage => thePackage.packageItem > 0)
      .map(thePackage => thePackage.costDefault + thePackage.costFar + thePackage.costIsland - (
        thePackage.promotion && thePackage.promotion.discount
          ? thePackage.promotion.discount.DiscountAmount
          : 0
      ))
    return packageList.length === 0 ? 0 : packageList.reduce((prev, curr) => prev + curr)
  },
  /** 依照 price_id 篩選，並回傳包裹陣列 */
  packageListByPriceId: (state) => (priceId) => {
    return state.packageList.filter(pkg => pkg.item.price_id === priceId)
  }
}

export const mutations = {
  resetState (state) {
    Object.assign(state, packageDeliveStoreInitState())
  },
  resetPackageList (state) {
    state.packageList = []
  },
  changeStep (state, step) {
    state.nowStep = step
    const stepper = document.querySelector('.multiple-layout .stepper')
    const header = document.querySelector('#header')
    if (!stepper || !header ||
      (stepper && header &&
        stepper.getBoundingClientRect().top <= header.clientHeight)) {
      goTo(0, { duration: 300, offset: 0, easing: 'easeInOutQuad' })
    }
  },
  updatePackageList (state, packageList) {
    state.packageList = _.cloneDeep(packageList)
  },
  updateKTJNoPickUpOrders (state, orderList) {
    state.KTJNoPickUpOrders = _.cloneDeep(orderList)
  },
  updateStep3Data (state, data) {
    state.step3Data = _.cloneDeep(data)
  },
  setSelectedDeliver (state, value) {
    state.selectedDeliver = value
  },
  setCommunityList (state, value) {
    state.communityList = value
  },
  setPkgNextLoading (state, value) {
    state.pkgNextLoading = value
  },
  setLogisticList (state, data) {
    state.logisticList = data
  },
  setPackageTypeOptions (state, options) {
    state.packageTypeOptions = options
  },
  setOrderPackageList (state, data) { // 訂單包裹列表
    state.orderPackageList = data
  }
}

export const actions = {
  async getOrderListByPage ({ commit, state, dispatch }, page) {
    const prePageCount = 30
    const { Data } = await this.$axios.$get('/api/v2/Order/GetOrderInfo', { params: { page, rows: prePageCount } })
    commit('pushOrderList', { Data: Data.Orders })
    if (Data.Orders.length < prePageCount) {
      commit('toggleStatus', { key: 'allLoadDown', status: true })
      return // 如果撈完了，就停止撈取
    }
    if (state.status.stop) {
      commit('toggleStatus', { key: 'allLoadDown', status: false })
      return
    }
    if (!state.status.firstDataDown) {
      commit('toggleStatus', { key: 'firstDataDown', status: true })
    }
    await dispatch('getOrderListByPage', page + 1)
  },
  async getHasKTJNoPickUpOrders ({ commit }) {
    try {
      const { data } = await this.$axios.get('/api/KTJ/GetNotPickUpOrders')
      commit('updateKTJNoPickUpOrders', data.Data.Orders)
    } catch (error) {
      return Promise.resolve()
    }
  },
  removeLocalData () {
    localStorage.removeItem('packageDeliveStore')
  }
}
